import { Entreprise } from '../../intervenant/models/entreprise.model';
import { Utilisateur } from '../../intervenant/models/utilisateur.model';

export class SuiviStockModel {
  static jsonMap = {
    idDeclaration: { key: 'idDeclaration', optional: true },
    idEntreprise: { key: 'idEntreprise', optional: true },
    dateDeclaration: { key: 'dateDeclaration', optional: true },
    dateDerniereMaj: { key: 'dateDerniereMaj', optional: true },
    dateDerniereValidation: { key: 'dateDerniereValidation', optional: true },
    idAuteurDerniereValidation: { key: 'idAuteurDerniereValidation', optional: true },
    qteTotale: { key: 'qteTotale', optional: true },
    qteBio: { key: 'qteBio', optional: true },
    codeEspece: { key: 'codeEspece', optional: true, default: '' }
  };

  idDeclaration: number = undefined;
  idEntreprise: number;
  entreprise: Entreprise;
  dateDeclaration: Date;
  dateDerniereMaj: Date;
  dateDerniereValidation: Date;
  idAuteurDerniereValidation: number;
  qteTotale: number;
  qteBio: number;
  codeEspece: string;

  auteurModification: Utilisateur;
  public estCochee: boolean = false;
  surface: number;
}
